import { KEYS_IN_ORDER, KEYS_PLUS_BUILDABILITY } from './keys';
export function isCompleteConfiguration(configuration) {
    const configurationKeys = KEYS_IN_ORDER;
    return configurationKeys.every((key) => Boolean(configuration[key]));
}
/**
 * Validate that all locked values in baseConfiguration
 * and compareConfiguration match
 *
 * @param baseConfiguration existing configuration
 * @param compareConfiguration new configuration to replace existing
 */
export function isConfigurationValidForContext(baseConfiguration, compareConfiguration, lockedParameters) {
    const lockedParameterKeys = KEYS_IN_ORDER.filter((key) => Boolean(lockedParameters[key]));
    return lockedParameterKeys.every((key) => Boolean(baseConfiguration[key] === compareConfiguration[key]));
}
export function areConfigurationsCompatible(baseConfiguration, compareConfiguration) {
    // check that everything except for options is the same
    const singlePropertiesMatch = Object.keys(baseConfiguration)
        .filter((key) => key !== 'buildabilityStatus' && key !== 'options')
        .every((key) => Boolean(baseConfiguration[key] &&
        baseConfiguration[key] === compareConfiguration[key]));
    if (!singlePropertiesMatch) {
        return false;
    }
    if (!baseConfiguration.options || !baseConfiguration.options.length) {
        return true;
    }
    const compareOptions = compareConfiguration.options;
    const optionsMatch = Boolean(compareOptions &&
        baseConfiguration.options.every((optionId) => compareOptions.indexOf(optionId) !== -1));
    return optionsMatch;
}
export function isSameConfiguration(configuration1, configuration2) {
    const configurationKeys = KEYS_PLUS_BUILDABILITY;
    const value = configuration1;
    const compare = configuration2;
    return (configurationKeys.every((key) => value[key] === compare[key]) &&
        equalsStringArray(value.options, compare.options));
}
function equalsStringArray(a1, a2) {
    if ((a1 === null || a1 === void 0 ? void 0 : a1.length) !== (a2 === null || a2 === void 0 ? void 0 : a2.length)) {
        return false;
    }
    const aa1 = (a1 ? [...a1] : []).sort();
    const aa2 = (a2 ? [...a2] : []).sort();
    const foundUnequal = aa1.some((value, index) => value !== aa2[index]);
    return !foundUnequal;
}
